export default "__VITE_ASSET__B0Wag6OK__"